<!-- 
Dialog for editing the public levy estimator configuration.

At the moment this just consists of the "enablePublicLevyEstimator" flag, so the dialog is just providing a toggle for that.
-->
<template>
  <v-dialog :value="show" persistent content-class="dialog sm">
    <v-card>
      <v-toolbar color="secondary" flat dark>
        <v-toolbar-title>Public levy estimator configuration</v-toolbar-title>
        <v-spacer/>
        <our-user-guide-button topic="levy-collection-setup" section="public-levy-estimator"/>
      </v-toolbar>
      <our-busy-indicator :show="busy"/>
      <v-card-text v-if="!state.loading">
        <p v-if="currentlyEnabled">
          Excluding the public levy estimator will make it inaccessible to the public. You should ensure that notices such as the
          early advice notice template do not include links to the public levy estimator.
        </p>
        <p v-else>
          Including the public levy estimator in the levy collection will allow it to be previewed internally before publishing. 
          Once published, the URL can be sent to providers in a notice or other communication.
        </p>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn :disabled="busy" flat @click="hide">Cancel</v-btn>
        <v-btn
          v-if="!state.loading"
          :disabled="busy"
          flat
          color="primary"
          @click.prevent="save"
        >
          {{ saveButtonCaption }}
        </v-btn>
      </v-card-actions>
    </v-card>
    <our-validation-dialog v-model="showValidationDialog" :state-error="state.error" />
  </v-dialog>
</template>

<script>
import * as action from "@/store/levy-collections/action-types";
import * as mutation from "@/store/levy-collections/mutation-types";

export default {
  model: {
    prop: "show",
    event: "update:show"
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    levyCollectionId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      showValidationDialog: false,
      currentlyEnabled: null
    };
  },
  computed: {
    state() {
      return this.$store.state.levyCollections.editPublicLevyEstimatorConfiguration;
    },
    busy() {
      return this.state.loading || this.state.saving;
    },
    saveButtonCaption() {
      return this.currentlyEnabled ? "Exclude public levy estimator" : "Include public levy estimator";
    }
  },
  watch: {
    async show(nowShowing) {
      if (nowShowing) {
        await this.$store.dispatch(action.EDIT_PUBLIC_LEVY_ESTIMATOR_CONFIGURATION_GET, this.levyCollectionId);
        this.currentlyEnabled = this.state.data.enablePublicLevyEstimator;
      }
    }
  },
  methods: {
    async save() {
      this.$store.commit(mutation.EDIT_PUBLIC_LEVY_ESTIMATOR_CONFIGURATION_SET_DATA, {
        enablePublicLevyEstimator: !this.currentlyEnabled
      });
      if (await this.$store.dispatch(action.EDIT_PUBLIC_LEVY_ESTIMATOR_CONFIGURATION_SAVE)) {
        this.hide();
      } else {
        this.showValidationDialog = true;
      }
    },
    hide() {
      this.$emit("update:show", false);
    }
  }
};
</script>
